<template>
   <div>
      <v-container>
         <v-row no-gutters dense class="d-flex">
            <v-col cols="12" md="4">
               <v-card outlined>
                  <table width="100%">
                     <tr>
                        <td width="70%">
                           {{ student.fullname }}
                        </td>
                        <td width="30%">
                           {{ student.gendertext }}
                        </td>
                     </tr>
                     <tr>
                        <td><label>Code:</label>{{ student.student_code }}</td>
                        <td><label>Year:</label> {{ student.ncyear }}</td>
                     </tr>
                  </table>
               </v-card>
            </v-col>
            <v-col cols="12" md="2">
               <v-card outlined class="text-center">
                  <v-btn
                     small
                     ref="PresentBtn"
                     fab
                     :value="student.school_id"
                     :color="presentcolor"
                     class="ma-2"
                     @click="ChangeBtnColor('1', student.school_id)"
                  >
                     <v-icon>mdi-account-outline</v-icon>
                  </v-btn>
                  <v-btn
                     small
                     ref="AbsentBtn"
                     fab
                     :value="student.id"
                     :color="absentcolor"
                     class="ma-2"
                     @click="ChangeBtnColor('0', student.school_id)"
                  >
                     <v-icon>mdi-account-off-outline</v-icon>
                  </v-btn>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
   </div>
</template>

<script>
   import {Attendance} from "@/common/constant.js";

   export default {
      props: {
         student: {
            type: Object,
         },
      },
      data() {
         return {
            ATTD: Object.freeze(Attendance),
            attendance: [],
            presentcolor: "",
            absentcolor: "",
            lastvalue: -1,
            studentattendance: null,

            COLOR_NONE: "",
            COLOR_PRESENT: "green white--text",
            COLOR_ABSENT: "red white--text",
         };
      },
      methods: {
         ChangeBtnColor(value, id) {
            this.studentattendance = {school_id: null, attend: null};
            if (this.lastvalue === this.ATTD.NA) {
               this.lastvalue = value;
            } else if (value === this.lastvalue) {
               // user clicked on a student already marked present or absent
               // this will clear the attendance status and will be deleted
               // from cca_attendance.
               this.presentcolor = this.COLOR_NONE;
               this.absentcolor = this.COLOR_NONE;
               this.lastvalue = this.ATTD.NA;

               this.studentattendance.school_id = id;
               this.studentattendance.attend = -1;
               this.$emit("save-attend", this.studentattendance);
               return;
            }

            if (value === "0") {
               this.absentcolor = this.COLOR_ABSENT;
               this.presentcolor = this.COLOR_NONE;
            } else if (value === "1") {
               this.absentcolor = this.COLOR_NONE;
               this.presentcolor = this.COLOR_PRESENT;
            }
            this.lastvalue = value;
            this.studentattendance.school_id = id;
            this.studentattendance.attend = value;

            // Return value to parent for update
            this.$emit("save-attend", this.studentattendance);
         },
      },
      mounted() {
         this.lastvalue = this.student.attendstatus;
         if (this.student.attendstatus === this.ATTD.NA) {
            this.presentcolor = this.COLOR_NONE;
            this.absentcolor = this.COLOR_NONE;
         } else if (this.student.attendstatus === this.ATTD.PRESENT) {
            this.absentcolor = this.COLOR_NONE;
            this.presentcolor = this.COLOR_PRESENT;
         } else if (this.student.attendstatus === this.ATTD.ABSENT) {
            this.absentcolor = this.COLOR_ABSENT;
            this.presentcolor = this.COLOR_NONE;
         }
      },
   };
</script>
